import VideoButton, { VideoButtonProps } from './VideoButton';

export type { VideoButtonProps };
export default VideoButton;
